import { ReactNode } from 'react';

import { labelToString } from './filter';

// autoHighlight 'always' keeps the top match highlighted from open and while
// the query changes, so Enter commits it. base-ui highlights a disabled top row
// too, and Enter on it commits nothing, so lists put disabled rows after the
// enabled ones. Root types the prop as boolean but its internals accept
// 'always' (https://github.com/mui/base-ui/pull/4189).
//
// keepHighlight preserves the highlight on the last hovered option when the
// pointer leaves the list — without it base-ui clears the highlight on
// hover-out and autoHighlight snaps it back to the first option. Root omits
// the prop from its public type but forwards it to AriaCombobox at runtime.
export const highlightBehaviorProps = {
  autoHighlight: 'always',
  keepHighlight: true,
} as unknown as { autoHighlight: boolean };

export const isSameOptionValue = (item: { value: unknown }, value: { value: unknown }) => {
  return item.value === value.value;
};

export const optionLabelToString = (item: { label: ReactNode; filterText?: string }) => {
  return labelToString(item.label) || item.filterText || '';
};
